module.exports = __webpack_public_path__ + "img/crx-green.d4d38bf7.svg";